import { types } from 'mobx-state-tree';

export const PurposeBlockModel = types.model('PurposeBlockModel', {
  purpose: types.maybe(types.string),
  workTypes: types.array(types.integer)
});
